import AOS from 'aos';
import {tns} from '../../node_modules/tiny-slider/src/tiny-slider';
import Cookies from '../../node_modules/js-cookie/src/js.cookie.js';

( function() {

    'use strict';

    // Allows us to add classes in Gutenberg to trigger AOS animations
    jQuery( '.fade-up' ).attr( 'data-aos', 'fade-up' );
    jQuery( '.fade-right' ).attr( 'data-aos', 'fade-right' );

    // AOS Init
    AOS.init( {
        once: true
    } );

    // Init
    navToggle();
    notificationBar();
    cookieBar();
    slideshowBlock();
    testimonialSlideShow();
    faq();
    socialSharing();
    searchIcon();
    $('document').ready(function(){
        headerHeight();
        modalToggle();
        mobileNav();
        odom();
        faqModal();
        patientList();
        if( $('.b40-testimonials .slides').is('*') ){
            runSlick();
        }
    });
    $(window).resize(function(){
        headerHeight();
        mobileNav();
    });
    
    //odom();

    function searchIcon(){
        $(".search i").on("click", function () {
            var searchInput = $("#search-input").val().trim();
            if (searchInput != null && searchInput !== "") {
                $(".search-form").submit();
                return;
            }
        });
    }


    $('.js-toggle-search').on('click', (e) => {
        e.preventDefault();
    
        $('.js-toggle-search').next('form').toggleClass('hidden');
        if($('.js-toggle-search i').hasClass('icon-search-1')) {
          $('.js-toggle-search i').removeClass('icon-search-1').addClass('icon-cancel');
        } else {
          $('.js-toggle-search i').removeClass('icon-cancel').addClass('icon-search-1');
        }
      });
    
      $('#s').on('focusout', (e) => {
        $('.js-toggle-search').next('form').toggleClass('hidden');
        if($('.js-toggle-search i').hasClass('icon-search-1')) {
          $('.js-toggle-search i').removeClass('icon-search-1').addClass('icon-cancel');
        } else {
          $('.js-toggle-search i').removeClass('icon-cancel').addClass('icon-search-1');
        }
      });
    
      $('.js-toggle-menu').on('click', (e) => {
        e.preventDefault();
    
        if($('.js-toggle-menu i').hasClass('icon-menu')) {
          $('.js-toggle-menu i').removeClass('icon-menu').addClass('icon-cancel');
          $('#mobilenavigation').fadeIn(350);
        } else {
          $('.js-toggle-menu i').removeClass('icon-cancel').addClass('icon-menu');
          $('#mobilenavigation').fadeOut(350);
        }
      });
    
    function mobileNav(){
        var 
            hpos = $('.main-header').offset().top,
            hh   = $('.main-header').height(),
            hoff = hpos + hh;
        $('#mobilenavigation, .main-content').css('top', hoff);
        $('.main-content').css('margin-bottom', hoff);
    }

    function navToggle() {
        
        $( '.navicon' ).click( function() {
            $( 'body' ).toggleClass( 'nav-is-active' );
        } );

    }

    function headerHeight() {
        var hh = $('#masthead').height();
        $('#main').css({
            'top': hh,
            'marginBottom': hh
        });
    }

    function modalToggle(){
        $('.js-toggle-modal').on('click', (e) => {
            e.preventDefault();
            $('.modal').toggle();
        });
    }

    // Slick JS for testimonials
    function runSlick() {
        $('.b40-testimonials .slides').slick({
            centerMode: true,
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            //centerPadding: '100px',
            autoplay: true,
            autoplaySpeed: 8000,
            dots: true,
            cssEase: 'linear',
            variableWidth: true,
            variableHeight: true,
            speed: 2000
        });
    }

    function faqModal() {
        $('.modal-trigger').on('click', function(){
            var 
                dm = $(this).attr('data-modal'),
                mod = $('.modal[data-modal="'+dm+'"]');
            mod.show();
            
        });

        $('.js-hide-modal').on('click', (e) => {
            e.preventDefault();
            $('.modal').hide();
        });
    }

    // Slideshow Block
    function slideshowBlock() {

        if ( $( '.b40-slideshow--slides' ).length > 0 ) {
            var slider = tns( {
                container: '.b40-slideshow--slides',
                controls: false,
                navPosition: 'bottom'
            } );
        }

    }
    

    // Patient List
    function patientList() {

        var 
            ffull = $('#patient-feed .person-block').length;   

        $('.filter-button').on('click', (e) => {
            e.preventDefault();
            var 
                self = e.target,
                filter = $(self).attr('data-filter'),
                flist = $("#patient-feed .patient-"+filter),    
                fcount = flist.length;
            
            if( $(self).hasClass('selected') ){

                $('.filter-buttons .btn').removeClass('selected');

                $('#patient-feed .person-block').show();

                $('#patient-pagination').pagination({
                    updateItems: ffull,
                    itemsOnPage: 6
                });

            } else {
                $('#patient-feed .person-block').hide();
                flist.show();
                
                $('#patient-pagination').pagination(
                    'updateItems', fcount
                );

                $('.filter-buttons .btn').removeClass('selected');
    
                $(self).addClass('selected');
            }


            
        });

            var items = $("#patient-feed .person-block");
        
            var numItems = ffull;
            var perPage = 6;
        
            items.slice(perPage).hide();
        
            $("#patient-pagination").pagination({
                items: numItems,
                itemsOnPage: perPage,
                cssStyle: "light-theme",
        
                // This is the actual page changing functionality.
                onPageClick: function(pageNumber) {
                    // We need to show and hide patients appropriately.
                    var showFrom = perPage * (pageNumber - 1);
                    var showTo = showFrom + perPage;
        
                    // We'll first hide everything...
                    items.hide()
                         // ... and then only show the appropriate rows.
                         .slice(showFrom, showTo).show();
                }
            });
        
        
        
            // EDIT: Let's cover URL fragments (i.e. #page-3 in the URL).
            // More thoroughly explained (including the regular expression) in: 
            // https://github.com/bilalakil/bin/tree/master/simplepagination/page-fragment/index.html
        
            // We'll create a function to check the URL fragment
            // and trigger a change of page accordingly.
            function checkFragment() {
                // If there's no hash, treat it like page 1.
                var hash = window.location.hash || "#page-1";
        
                // We'll use a regular expression to check the hash string.
                hash = hash.match(/^#page-(\d+)$/);
        
                if(hash) {
                    // The `selectPage` function is described in the documentation.
                    // We've captured the page number in a regex group: `(\d+)`.
                    $("#patient-pagination").pagination("selectPage", parseInt(hash[1]));
                }
            };
        
            // We'll call this function whenever back/forward is pressed...
            $(window).bind("popstate", checkFragment);
        
            // ... and we'll also call it when the page has loaded
            // (which is right now).
            checkFragment();
        

    }

    

    // Odometer numbers
    function odom() {
        $('.number').each((i, el) => {
            new Odometer({
            el: el,
            value: 0,
            format: '',
            theme: 'plaza'
            }).update($(el).attr('data-number'));
        });
    };

    function notificationBar() {

        var cookieName = $( 'input[name="cookie_name"]' ).val(),
            cookieExpire = $( 'input[name="cookie_expire_date"]' ).val(),
            notificationBar = $( '.notification-bar' ),
            showBar = true,
            expires = {};

        if ( cookieExpire ) {
            cookieExpire = cookieExpire.split( "-" );
            var cookieExpireDate = new Date( cookieExpire[ 0 ], cookieExpire[ 1 ] - 1, cookieExpire[ 2 ] );
            expires = {expires: cookieExpireDate};
        }

        // Don't show the bar if the user has already closed it
        if ( 'hide' === Cookies.get( cookieName ) ) {
            showBar = false;
        }

        // Show the bar
        if ( notificationBar.length > 0 && true === showBar ) {
            notificationBar.show();
        }

        // Hide the bar and create a cookie if needed
        $( '.notification-close' ).click( function ( e ) {
            e.preventDefault();
            notificationBar.show();

            if ( cookieName ) {
                Cookies.set( cookieName, 'hide', expires );
            }

        } );

    }

    function cookieBar() {

        var cookie = Cookies.get('cookie_notice');

        if (cookie != 'hide') {
            $('.b40-cookie-notice').show();
        }

        $('.b40-cookie-notice a').click(function(e) {

            e.preventDefault();

            Cookies.set('cookie_notice', 'hide');

            $('.b40-cookie-notice').slideUp();

        });

    }

    // Testimonial Slideshow
    function testimonialSlideShow() {

        if ( $( '.b40-testimonials-slider' ).length > 0 ) {
            var slider = tns( {
                autoHeight: true,
                container: '.b40-testimonials-slider',
                controls: false,
                navPosition: 'bottom'
            } );
        }

    }

    // Prevent url bar from changing on faq anchor click
	function faq() {

        // List View Click
		$( '.b40-faq-questions li a' ).click( function( e ) {
            e.preventDefault();
            
			var hash = $( this ).attr( 'href' ),
				offset = 0;


			if ( $( 'body.customize-support' ).length ) {
				offset = 32;
			}

			$( 'html, body' ).animate( {scrollTop: $( hash ).offset().top - offset}, 0 );
		} );

		$( '.b40-faq-top' ).click( function( e ) {
			e.preventDefault();
			$( window ).scrollTop( 0 );
        } );

        // Accordion Toggle
        $('.b40-faq-accordion .b40-faq-question').click(function(e) {

            var item = $(this).parent();

            if ( item.hasClass('active') ) {
                item.removeClass('active');
                $(this).next('.b40-faq-answer').slideToggle();
            } else {
                item.addClass('active');
                item.siblings().removeClass('active');
                item.siblings().find('.b40-faq-answer').slideUp();
                $(this).next('.b40-faq-answer').slideToggle();
            }

        });
        
    }

    // Social Sharing
    function socialSharing() {

        $('.facebook-share').click(function(e) {

            e.preventDefault();

            var url = $(this).attr('data-url');
            
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + url, "pop", "width=600, height=400, scrollbars=no");
            return false;

        });

        $('.twitter-share').click(function(e) {

            e.preventDefault();

            var url = $(this).attr('data-url');
            
            window.open("https://twitter.com/intent/tweet?url=" + url, "pop", "width=600, height=400, scrollbars=no");
            return false;

        });

        $('.linkedin-share').click(function(e) {

            e.preventDefault();

            var url = $(this).attr('data-url');
            
            window.open("https://www.linkedin.com/shareArticle?mini=true&url=" + url, "pop", "width=600, height=400, scrollbars=no");
            return false;

        });

    }
    
} )();